<div class="modal-dialog"
     id="new-request">
  <div class="modal-content p-0">
    <div class="modal-header">
      <button (click)="noAction()"
              class="close"
              data-dismiss="modal"
              type="button">
        <div class="dialog-close"></div>
      </button>
      <span
        *ngIf="addOrUpdateSpacesOptions.space.SpaceId === undefined">{{ 'Insert' | translate }}
        : {{ 'Additive' | translate }}</span>
      <span
        *ngIf="addOrUpdateSpacesOptions.space.SpaceId !== undefined">{{ 'Update' | translate }}
        : {{ 'Additive' | translate }}</span>
    </div>
  </div>
</div>
<mat-dialog-content class="mat-typography py-0">
  <div class="row my-4 pb-1 ">
    <div class="col-md-6 col-12">
      <app-frontend-input [(value)]="title"
                          [required]="true"
                          [title]="'Title'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-input [(value)]="standardCode"
                          [required]="true"
                          [title]="'StandardCode'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-input [(value)]="maxCapacity"
                          [required]="false"
                          [title]="'MaxCapacity'"
                          [type]="'number'"></app-frontend-input>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-select
        [(value)]="businessId"
        [controller]="'businesses'"
        [disabled]="addOrUpdateSpacesOptions.space.SpaceId !== undefined"
        [displayKey]="'Title'"
        [fieldName]="'BusinessId'"
        [method]="'getBranches'"
        [microservice]="Constant.FOOD_SHOP"
        [protocolMethod]="'POST'"
        [required]="true"
        [searchOnKey]="'Title'"
        [selectedOptions]="[addOrUpdateSpacesOptions.space.Business]"
        [title]="'Branch'"
        [version]="'v1'"></app-frontend-select>
    </div>
    <div class="col-md-6 col-12">
      <app-frontend-check-box [(value)]="isActive"
                              [title]="'IsActive'"></app-frontend-check-box>
    </div>
  </div>
</mat-dialog-content>
<div class="dialog-footer">
  <mat-dialog-actions align="end"
                      class="py-0">
    <div class="col-12 d-flex align-items-center justify-content-end footer"
         style="gap: 16px">
      <app-frontend-button (onSubmit)="onSubmitClicked()"
                           [Image]="true"
                           [class]="'card-green'"
                           [disabled]="false"
                           [src]="'icons/tick-square.svg'"
                           [title]="'Submit'"
                           [validationRequired]="true">
      </app-frontend-button>
      <app-frontend-button (click)="noAction()"
                           [Image]="true"
                           [class]="'card-yellow'"
                           [disabled]="false"
                           [src]="'icons/close-square.svg'"
                           [title]="'Cancel'">
      </app-frontend-button>
    </div>
  </mat-dialog-actions>
</div>
